import { Button, Checkbox, Menu, Portal, Stack } from '@chakra-ui/react';
import { daysOrder, formatLocationShort, formatWeekday, locations } from '@opanuj/shared/utils';
import { Location } from '@opanuj/shared/types';

export type LessonRescheduleFormFiltersProps = {
	teachersOptions: string[];
	teachersValue: string[];
	onTeachersChange: (teachers: string[]) => void;
	daysValue: string[];
	onDaysChange: (days: string[]) => void;
	locationsValue: Location[];
	onLocationsChange: (locations: Location[]) => void;
};

const LessonRescheduleFormFilters = (
	props: LessonRescheduleFormFiltersProps
) => {
	const filtersCount =
		props.teachersValue.length + props.daysValue.length + props.locationsValue.length;

	return (
        <Menu.Root closeOnSelect={false}>
            <Menu.Trigger asChild><Button colorPalette={filtersCount ? 'yellow' : 'gray'}>
                    {filtersCount ? `Filtruj (${filtersCount})` : 'Filtruj'}
                </Button></Menu.Trigger>
            <Portal>
				<Menu.Positioner><Menu.Content>
                    <Menu.ItemGroup title="Korepetytor">
                        <Stack gap={2} px={3} py={2}>
                            {props.teachersOptions.map((teacher) => (
                                <Checkbox.Root
                                    key={teacher}
                                    checked={props.teachersValue.includes(teacher)}
                                    onCheckedChange={({ checked }) => {
                                        props.onTeachersChange(
                                            checked === true
                                                ? props.teachersValue.concat(teacher)
                                                : props.teachersValue.filter((value) => value !== teacher)
                                        );
                                    }}
                                >
                                    <Checkbox.HiddenInput />
                                    <Checkbox.Control />
                                    <Checkbox.Label>{teacher}</Checkbox.Label>
                                </Checkbox.Root>
                            ))}
                        </Stack>
                    </Menu.ItemGroup>
                    <Menu.Separator />
                    <Menu.ItemGroup title="Dzień tygodnia">
                        <Stack gap={2} px={3} py={2}>
                            {daysOrder.map((day) => (
                                <Checkbox.Root
                                    key={day}
                                    checked={props.daysValue.includes(day)}
                                    onCheckedChange={({ checked }) => {
                                        props.onDaysChange(
                                            checked === true
                                                ? props.daysValue.concat(day)
                                                : props.daysValue.filter((value) => value !== day)
                                        );
                                    }}
                                >
                                    <Checkbox.HiddenInput />
                                    <Checkbox.Control />
                                    <Checkbox.Label>{formatWeekday(day)}</Checkbox.Label>
                                </Checkbox.Root>
                            ))}
                        </Stack>
                    </Menu.ItemGroup>
                    <Menu.Separator />
                    <Menu.ItemGroup title="Placówka">
                        <Stack gap={2} px={3} py={2}>
                            {locations.map((location) => (
                                <Checkbox.Root
                                    key={location}
                                    checked={props.locationsValue.includes(location)}
                                    onCheckedChange={({ checked }) => {
                                        props.onLocationsChange(
                                            checked === true
                                                ? props.locationsValue.concat(location)
                                                : props.locationsValue.filter((value) => value !== location)
                                        );
                                    }}
                                >
                                    <Checkbox.HiddenInput />
                                    <Checkbox.Control />
                                    <Checkbox.Label>{formatLocationShort(location as Location)}</Checkbox.Label>
                                </Checkbox.Root>
                            ))}
                        </Stack>
                    </Menu.ItemGroup>
                </Menu.Content></Menu.Positioner>
			</Portal>
        </Menu.Root>
    );
};

export default LessonRescheduleFormFilters;